import { getMe, getMePrivacySettings } from './user';
import { createAction } from 'redux-actions';

const requestInitialData = createAction('INITIAL_DATA_REQUEST');
const receiveInitialData = createAction('INITIAL_DATA_SUCCESS');
const failInitialData = createAction('INITIAL_DATA_ERROR');

export const fetchInitialData = () => async dispatch => {
  dispatch(requestInitialData());
  const isImpersonating = Boolean(
    JSON.parse(localStorage.getItem('state'))?.user?.impersonatedUser
      ?.accessToken,
  );

  try {
    await Promise.all(
      [
        dispatch(getMe()),
        isImpersonating ? null : dispatch(getMePrivacySettings()),
      ].filter(Boolean),
    );
    dispatch(receiveInitialData());
  } catch (e) {
    dispatch(failInitialData());
  }
};
